const routesR = [
    {
        path: '/index',
        name: '磐石首页',
        component: () => import('../pages/home'),
        children: [],
    },
    {
        path: '/guide',
        name: '引导',
        component: () => import('../pages/guide'),
        children: [
            {
                path: 'process',
                realPath: '/guide/process',
                name: '引导-系统创建',
                component: () => import('../pages/guide/process.vue'),
                children: []
            }
        ],
    },
    {
        path: '/domainname',
        name: '域名管理',
        icon: 'code',
        component: () => import('../pages/domainname'),
        children: [
            {
                path: 'list',
                realPath: '/domainname/list',
                name: '域名管理-域名列表',
                component: () => import('../pages/domainname/list.vue'),
                children: []
            },
            {
                path: ':action(add|edit|detail)',
                name: '域名管理-mixAction',
                component: () => import('../pages/domainname/item.vue'),
                children: []
            }
        ]
    }, {
        path: '/tools',
        name: '运维工具',
        icon: 'code',
        component: () => import('../pages/devicelog'),
        children: [
            {
                path: 'alarmmanager',
                realPath: '/tools/alarmmanager',
                name: '告警管理',
                icon: 'code',
                component: () => import('../pages/alarmmanager'),
                children: [
                    {
                        path: 'list',
                        realPath: '/tools/alarmmanager/list',
                        name: '告警管理-告警日志列表',
                        component: () => import('../pages/alarmmanager/list.vue'),
                        children: []
                    },
                    {
                        path: 'blocklist',
                        realPath: '/tools/alarmmanager/blocklist',
                        name: '告警管理-告警屏蔽服务列表',
                        component: () => import('../pages/alarmmanager/blocklist.vue'),
                        children: []
                    },
                    {
                        path: 'analysischartindex',
                        realPath: '/tools/alarmmanager/analysischartindex',
                        name: '告警管理-告警分析',
                        component: () => import('../pages/alarmmanager/analysischartindex.vue'),
                        children: []
                    },
                    {
                        path: ':action(appdetails)',
                        realPath: '/tools/alarmmanager/analysischart',
                        name: '告警管理-告警分析图',
                        component: () => import('../pages/alarmmanager/analysischart.vue'),
                        children: []
                    },
                    {
                        path: ':action(serviceurldetails)',
                        name: '告警管理-告警服务详情-mixAction',
                        component: () => import('../pages/alarmmanager/analysischartitem.vue'),
                        children: []
                    },
                    {
                        path: ':action(edit)',
                        name: '告警管理-告警详情-mixAction',
                        component: () => import('../pages/alarmmanager/item.vue'),
                        children: []
                    },
                    {
                        path: 'userlist',
                        realPath: '/tools/alarmmanager/userlist',
                        name: '告警管理-告警人员管理',
                        component: () => import('../pages/alarmmanager/userlist.vue'),
                        children: []
                    },
                    {
                        path: ':action(useredit|useradd)',
                        name: '告警管理-告警人员-mixAction',
                        component: () => import('../pages/alarmmanager/useritem.vue'),
                        children: []
                    },
                    {
                        path: 'grouplist',
                        realPath: '/tools/alarmmanager/grouplist',
                        name: '分组管理-告警人员分组管理',
                        component: () => import('../pages/alarmmanager/grouplist.vue'),
                        children: []
                    },
                    {
                        path: ':action(groupedit|groupadd)',
                        name: '分组管理-分组-mixAction',
                        component: () => import('../pages/alarmmanager/groupitem.vue'),
                        children: []
                    },
                    {
                        path: 'dingdinglist',
                        realPath: '/tools/alarmmanager/dingdinglist',
                        name: '钉钉群告警',
                        component: () => import('../pages/alarmconfig/dingdinglist.vue'),
                        children: []
                    },
                    {
                        path: ':action(dingdingedit|dingdingadd)',
                        name: '钉钉群告警-mixAction',
                        component: () => import('../pages/alarmconfig/dingdingitem.vue'),
                        children: []
                    },
                    {
                        path: ':action(dingdingrelation)',
                        name: '钉钉群告警-mixAction',
                        component: () => import('../pages/alarmconfig/dingdingrelation.vue'),
                        children: []
                    },
                    {
                        path: ':action(dingdingrelationsys)',
                        name: '钉钉群告警-mixAction',
                        component: () => import('../pages/alarmconfig/dingdingrelationsys.vue'),
                        children: []
                    },
                    {
                        path: 'emailandsmslist',
                        realPath: '/tools/alarmmanager/emailandsmslist',
                        name: '邮箱&短信配置管理',
                        component: () => import('../pages/alarmconfig/emailandsmslist.vue'),
                        children: []
                    },
                    {
                        path: ':action(emailedit|emailadd)',
                        name: '邮箱&短信配置管理-mixAction',
                        component: () => import('../pages/alarmconfig/emailandsmsitem.vue'),
                        children: []
                    },
                    {
                        path: 'alertconfiglist',
                        realPath: '/tools/alarmmanager/alertconfiglist',
                        name: '告警服务配置管理',
                        component: () => import('../pages/alarmconfig/alertconfiglist.vue'),
                        children: []
                    },
                    {
                        path: ':action(alertconfigedit|alertconfigadd)',
                        name: '告警服务配置管理-mixAction',
                        component: () => import('../pages/alarmconfig/alertconfigitem.vue'),
                        children: []
                    },
                    {
                        path: 'alerthistorylist',
                        realPath: '/tools/alarmmanager/alerthistorylist',
                        name: '告警历史管理',
                        component: () => import('../pages/alarmconfig/alerthistorylist.vue'),
                        children: []
                    },
                    {
                        path: ':action(alerthistroydetail|)',
                        name: '告警历史详情-mixAction',
                        component: () => import('../pages/alarmconfig/alerthistoryitem.vue'),
                        children: []
                    },
                ]
            },
            {
                path: 'list',
                realPath: '/tools/list',
                name: '收银机日志管理-日志列表',
                component: () => import('../pages/devicelog/list'),
                children: []
            },
            {
                path: ':action(pushadd|pushdit|pushdetail)',
                name: '收银机日志管理-日志上传-mixAction',
                component: () => import('../pages/devicelog/item.vue'),
                children: []
            },
        ]
    },

    {
        path: '/message',
        name: '短信管理v5',
        icon: 'code',
        component: () => import('../pages/socketmanager'),
        children: [
            {
                path: 'smsmanager',
                realPath: '/message/smsmanager',
                name: '短信管理',
                icon: 'code',
                component: () => import('../pages/smsmanager'),
                children: [
                    {
                        path: 'analysis',
                        realPath: '/message/smsmanager/analysis',
                        name: '短信管理-统计',
                        component: () => import('../pages/smsmanager/analysis.vue'),
                        children: []
                    },
                    {
                        path: 'sendmsglist',
                        realPath: '/message/smsmanager/sendmsglist',
                        name: '短信管理-短信列表',
                        component: () => import('../pages/smsmanager/sendmsglist.vue'),
                        children: []
                    },

                    {
                        path: ':action(smsDetailUrl)',
                        name: '短信管理-短信详情-mixAction',
                        component: () => import('../pages/smsmanager/item.vue'),
                        children: []
                    },
                    {
                        path: 'signlist',
                        realPath: '/message/smsmanager/signlist',
                        name: '短信管理-动态签名列表',
                        component: () => import('../pages/smsmanager/smssign/signlist.vue'),
                        children: []
                    },
                    {
                        path: ':action(addSign|editSign|detailSign)',
                        name: '动态签名管理-签名注册-mixAction',
                        component: () => import('../pages/smsmanager/smssign/signitem.vue'),
                        children: []
                    },
                    {
                        path: 'templatelist',
                        realPath: '/message/smsmanager/templatelist',
                        name: '短信管理-短信模版列表',
                        component: () => import('../pages/smsmanager/smstemplate/list.vue'),
                        children: []
                    },
                    {
                        path: ':action(addTemplate|editTemplate|detailTemplate)',
                        name: '模版管理-模版-mixAction',
                        component: () => import('../pages/smsmanager/smstemplate/item.vue'),
                        children: []
                    },
                    {
                        path: 'signapply',
                        realPath: '/message/smsmanager/signapply',
                        name: '签名申请-申请签名列表',
                        component: () => import('../pages/smsmanager/smssignapply/list.vue'),
                        children: []
                    },
                    {
                        path: ':action(addSignApply|editSignApply|detailSignApply)',
                        name: '签名申请管理-签名-mixAction',
                        component: () => import('../pages/smsmanager/smssignapply/item.vue'),
                        children: []
                    },
                    {
                        path: 'templateapply',
                        realPath: '/message/smsmanager/templateapply',
                        name: '模板申请-申请模板列表',
                        component: () => import('../pages/smsmanager/smstemplateapply/list.vue'),
                        children: []
                    },
                    {
                        path: ':action(addTemplateApply|editTemplateApply|detailTemplateApply)',
                        name: '签名模板管理-模板-mixAction',
                        component: () => import('../pages/smsmanager/smstemplateapply/item.vue'),
                        children: []
                    },
                    {
                        path: 'signmanager',
                        realPath: '/message/smsmanager/signmanager',
                        name: '短信管理-签名管理',
                        component: () => import('../pages/smsmanager/signmanager/list.vue'),
                        children: []
                    },
                    {
                        path: ':action(addsignmanager|editsignmanager|detailsignmanager)',
                        name: '短信管理-签名管理-mixAction',
                        component: () => import('../pages/smsmanager/signmanager/item.vue'),
                        children: []
                    },
                    {
                        path: 'templatmanager',
                        realPath: '/message/smsmanager/templatmanager',
                        name: '短信管理-模板管理',
                        component: () => import('../pages/smsmanager/templatmanager/list.vue'),
                        children: []
                    },
                    {
                        path: ':action(addtemplatmanager|edittemplatmanager|detailtemplatmanager)',
                        name: '短信管理-模板管理-mixAction',
                        component: () => import('../pages/smsmanager/templatmanager/item.vue'),
                        children: []
                    },
                ]
            },
            {
                path: 'wxtemplatemanager',
                realPath: '/message/wxtemplatemanager',
                name: '微信模版管理',
                icon: 'code',
                component: () => import('../pages/wxtemplatemanager'),
                children: [
                    {
                        path: 'templateheadlist',
                        realPath: '/message/wxtemplatemanager/templateheadlist',
                        name: '模版管理-新版微信模板消息编号表',
                        component: () => import('../pages/wxtemplatemanager/newtemplatehead/list.vue'),
                        children: []
                    },
                    {
                        path: ':action(addheadtemplate|editheadTemplate|detailheadTemplate)',
                        name: '模版管理-新版微信模板消息-mixAction',
                        component: () => import('../pages/wxtemplatemanager/newtemplatehead/item.vue'),
                        children: []
                    },
                    {
                        path: 'templatesublist',
                        realPath: '/message/wxtemplatemanager/templatesublist',
                        name: '模版管理-新版微信模板消息配置',
                        component: () => import('../pages/wxtemplatemanager/newtemplatesub/list.vue'),
                        children: []
                    },
                    {
                        path: ':action(addsubtemplate|editsubTemplate|detailsubTemplate)',
                        name: '模版管理-新版微信模板消息配置-mixAction',
                        component: () => import('../pages/wxtemplatemanager/newtemplatesub/item.vue'),
                        children: []
                    },
                    {
                        path: 'templateoldlist',
                        realPath: '/message/wxtemplatemanager/templateoldlist',
                        name: '模版管理-老版微信模板消息配置',
                        component: () => import('../pages/wxtemplatemanager/oldtemplate/list.vue'),
                        children: []
                    },
                    {
                        path: ':action(addoldtemplate|editoldTemplate|detailoldTemplate)',
                        name: '模版管理-老版微信模板消息配置-mixAction',
                        component: () => import('../pages/wxtemplatemanager/oldtemplate/item.vue'),
                        children: []
                    },
                ]
            },

        ]
    },
    {
        path: '/mcmsmanager',
        name: '消息中心',
        icon: 'message',
        component: () => import('../pages/mcmsmanager'),
        children: [
            {
                path: 'type',
                realPath: '/mcmsmanager/type',
                name: '消息中心-类型管理',
                component: () => import('../pages/mcmsmanager/type'),
                children: [
                    {
                        path: 'businesstype',
                        realPath: '/mcmsmanager/type/businesstype',
                        name: '消息中心-类型管理-业务类型',
                        component: () => import('../pages/mcmsmanager/type/businesstype/list'),
                        children: []
                    },
                    {
                        path: ':action(add_businesstype|edit_businesstype|detail_businesstype)',
                        name: '消息中心-类型管理-业务类型-mixAction',
                        component: () => import('../pages/mcmsmanager/type/businesstype/item'),
                        children: []
                    },

                    {
                        path: 'servicetype',
                        realPath: '/mcmsmanager/type/servicetype',
                        name: '消息中心-类型管理-业务分类',
                        component: () => import('../pages/mcmsmanager/type/servicetype/list'),
                        children: []
                    },
                    {
                        path: ':action(add_servicetype|edit_servicetype|detail_servicetype)',
                        name: '消息中心-类型管理-业务分类-mixAction',
                        component: () => import('../pages/mcmsmanager/type/servicetype/item'),
                        children: []
                    },
                    {
                        path: 'passwaytype',
                        realPath: '/mcmsmanager/type/passwaytype',
                        name: '消息中心-类型管理-通道类型',
                        component: () => import('../pages/mcmsmanager/type/passwaytype/list'),
                        children: []
                    },
                    {
                        path: ':action(add_passwaytype|edit_passwaytype|detail_passwaytype)',
                        name: '消息中心-类型管理-通道类型-mixAction',
                        component: () => import('../pages/mcmsmanager/type/passwaytype/item'),
                        children: []
                    },
                    {
                        path: 'platformtype',
                        realPath: '/mcmsmanager/type/platformtype',
                        name: '消息中心-类型管理-平台类型',
                        component: () => import('../pages/mcmsmanager/type/platformtype/list'),
                        children: []
                    },
                    {
                        path: ':action(add_platformtype|edit_platformtype|detail_platformtype)',
                        name: '消息中心-类型管理-平台类型-mixAction',
                        component: () => import('../pages/mcmsmanager/type/platformtype/item'),
                        children: []
                    },
                ]
            },
            {
                path: 'channel',
                realPath: '/mcmsmanager/channel',
                name: '消息中心-配置管理',
                component: () => import('../pages/mcmsmanager/channel'),
                children: [
                    {
                        path: 'channellist',
                        realPath: '/mcmsmanager/channel/channellist',
                        name: '消息中心-配置管理-渠道管理',
                        component: () => import('../pages/mcmsmanager/channel/channel/list'),
                        children: []
                    },
                    {
                        path: ':action(add_channel|edit_channel|detail_channel)',
                        name: '消息中心-配置管理-渠道管理-mixAction',
                        component: () => import('../pages/mcmsmanager/channel/channel/item'),
                        children: []
                    },
                    {
                        path: 'bind',
                        realPath: '/mcmsmanager/channel/bind',
                        name: '消息中心-配置管理-通道设置',
                        component: () => import('../pages/mcmsmanager/channel/bind/list'),
                        children: []
                    },
                    {
                        path: 'passwaylist',
                        realPath: '/mcmsmanager/channel/passwaylist',
                        name: '消息中心-配置管理-通道管理',
                        component: () => import('../pages/mcmsmanager/channel/passway/list'),
                        children: []
                    },
                    {
                        path: ':action(add_passway|edit_passway|detail_passway)',
                        name: '消息中心-配置管理-通道管理-mixAction',
                        component: () => import('../pages/mcmsmanager/channel/passway/item'),
                        children: []
                    },

                ]
            },
            {
                path: 'templete',
                realPath: '/mcmsmanager/templete',
                name: '消息中心-模板管理',
                component: () => import('../pages/mcmsmanager/templete'),
                children: [
                    {
                        path: 'app',
                        realPath: '/mcmsmanager/templete/app',
                        name: '消息中心-模板管理-站内信模板',
                        component: () => import('../pages/mcmsmanager/templete/list'),
                        children: []
                    },
                    {
                        path: ':action(add_templete|edit_templete|detail_templete)',
                        name: '消息中心-模板管理-站内信模板-mixAction',
                        component: () => import('../pages/mcmsmanager/templete/item'),
                        children: []
                    },
                ]
            },

            {
                path: 'message',
                realPath: '/mcmsmanager/message',
                name: '消息中心-消息管理',
                component: () => import('../pages/mcmsmanager/message'),
                children: [
                    {
                        path: 'messagepush',
                        realPath: '/mcmsmanager/message/messagepush',
                        name: '消息中心-消息管理-消息推送',
                        component: () => import('../pages/mcmsmanager/message/messagepush/pushIndex'),
                        children: []
                    },
                    {
                        path: ':action(msgIndex)',
                        name: '消息中心-消息管理-消息推送-mixAction',
                        component: () => import('../pages/mcmsmanager/message/messagepush/msgIndex'),
                        children: []
                    },
                    {
                        path: 'pushmessage',
                        realPath: '/mcmsmanager/message/pushmessage',
                        name: '消息中心-消息管理-推送记录',
                        component: () => import('../pages/mcmsmanager/message/pushmessage/list'),
                        children: []
                    },
                    {
                        path: 'messagehistory',
                        realPath: '/mcmsmanager/message/messagehistory',
                        name: '消息中心-消息管理-站内信推送历史',
                        component: () => import('../pages/mcmsmanager/message/messagehistory/list'),
                        children: []
                    },
                    {
                        path: 'wshistory',
                        realPath: '/mcmsmanager/message/wshistory',
                        name: '消息中心-消息管理-WSV5推送历史',
                        component: () => import('../pages/mcmsmanager/message/wshistory/list'),
                        children: []
                    },
                    {
                        path: 'wshistoryV3',
                        realPath: '/mcmsmanager/message/wshistoryV3',
                        name: '消息中心-消息管理-WSV3推送历史',
                        component: () => import('../pages/mcmsmanager/message/wshistoryV3/list'),
                        children: []
                    },
                ]
            },
            {
                path: 'pushsum',
                realPath: '/mcmsmanager/pushsum',
                name: '消息统计',
                component: () => import('../pages/mcmsmanager/pushsum'),
                children: [
                    {
                        path: 'appreach',
                        realPath: '/mcmsmanager/pushsum/appreach',
                        name: '消息中心-消息统计-站内信统计',
                        component: () => import('../pages/mcmsmanager/pushsum/appreach/list'),
                        children: []
                    },
                    {
                        path: 'wsreach',
                        realPath: '/mcmsmanager/pushsum/wsreach',
                        name: '消息中心-消息统计-推送触达率',
                        component: () => import('../pages/mcmsmanager/pushsum/wsreach/list'),
                        children: []
                    },
                    {
                        path: 'smsreach',
                        realPath: '/mcmsmanager/pushsum/smsreach',
                        name: '消息中心-消息统计-短信统计',
                        component: () => import('../pages/mcmsmanager/pushsum/smsreach/list'),
                        children: []
                    },
                    {
                        path: 'msgsum',
                        realPath: '/mcmsmanager/pushsum/msgsum',
                        name: '消息中心-消息统计-消息统计',
                        component: () => import('../pages/mcmsmanager/pushsum/msgsum/list'),
                        children: []
                    },
                    {
                        path: 'ipstat',
                        realPath: '/mcmsmanager/pushsum/ipstat',
                        name: '消息中心-消息统计-IP监控',
                        component: () => import('../pages/mcmsmanager/wsmsip/ipstat/list'),
                        children: []
                    },
                    {
                        path: 'ipstatdetail',
                        realPath: '/mcmsmanager/pushsum/ipstatdetail',
                        name: '消息中心-消息统计-IP监控明细',
                        component: () => import('../pages/mcmsmanager/wsmsip/ipstatdetail/list'),
                        children: []
                    },
                ]
            },
            {
                path: 'target',
                realPath: '/mcmsmanager/target',
                name: '目标管理',
                component: () => import('../pages/mcmsmanager/target'),
                children: [
                    {
                        path: 'wsdeviceV3',
                        realPath: '/mcmsmanager/target/wsdeviceV3',
                        name: '消息中心-目标管理-v3推送设备',
                        component: () => import('../pages/mcmsmanager/target/wsdeviceV3/list'),
                        children: []
                    },

                    {
                        path: 'wsdevice',
                        realPath: '/mcmsmanager/target/wsdevice',
                        name: '消息中心-目标管理-v5推送设备',
                        component: () => import('../pages/mcmsmanager/target/wsdevice/list'),
                        children: []
                    },
                    {
                        path: 'user',
                        realPath: '/mcmsmanager/target/user',
                        name: '消息中心-目标管理-目标用户管理',
                        component: () => import('../pages/mcmsmanager/target/user/list'),
                        children: []
                    },
                    {
                        path: ':action(add_user|edit_user|detail_user)',
                        name: '消息中心-目标管理-目标用户管理-mixAction',
                        component: () => import('../pages/mcmsmanager/target/user/item'),
                        children: []
                    },
                ]
            },

        ]
    }, {
        path: '/system',
        name: '系统管理',
        icon: 'code',
        component: () => import('../pages/system'),
        children: [
            {
                path: 'syslist',
                realPath: '/system/syslist',
                name: '系统管理-系统注册',
                component: () => import('../pages/system/sysManager/syslist'),
                children: []
            },
            {
                path: ':action(add|edit|detail)',
                name: '系统管理-系统注册-mixAction',
                component: () => import('../pages/system/sysManager/sysitem.vue'),
                children: []
            },
            {
                path: 'platformlist',
                realPath: '/system/platformlist',
                name: '系统管理-平台管理',
                component: () => import('../pages/system/platformlist/list'),
                children: []
            },
            {
                path: ':action(add_platformtype|edit_platformtype|detail_platformtype)',
                name: '系统管理-平台管理-mixAction',
                component: () => import('../pages/system/platformlist/item.vue'),
                children: []
            },
            {
                path: 'appmanage',
                realPath: '/system/appmanage',
                name: '系统管理-应用模块',
                component: () => import('../pages/system/appManager/appManage'),
                children: []
            },
            {
                path: ':action(addapp|editapp|detailapp)',
                name: '系统管理-应用模块-mixAction',
                component: () => import('../pages/system/appManager/appItem.vue'),
                children: []
            },
            {
                path: 'monitor',
                realPath: '/system/monitor',
                name: '系统管理-系统探活',
                component: () => import('../pages/system/monitor/monitor.vue'),
                children: []
            },
            {
                path: 'appnode',
                realPath: '/system/monitor/appnode',
                name: '系统管理-系统探活-节点',
                component: () => import('../pages/system/monitor/appnode.vue'),
                children: []
            },
            {
                path: 'domainurl',
                realPath: '/system/domainurl',
                name: '系统管理-系统创建',
                component: () => import('../pages/system/projectmanager/list'),
                children: []
            },
            {
                path: ':action(adddomainurl|editdomainurl|detaildomainurl|copydomainurl)',
                name: '系统管理-应用域名-mixAction',
                component: () => import('../pages/system/domainurl/item.vue'),
                children: []
            },
        ]
    },
    {
        path: '/configcenter',
        name: '配置中心',
        icon: 'file-text',
        component: () => import('../pages/configcenter'),
        children: [

            {
                path: 'filemanage',
                realPath: '/configcenter/filemanage',
                name: '应用配置',
                component: () => import('../pages/configcenter/fileManager/fileManage.vue'),
                children: []
            },
            {
                path: ':action(edit)',
                name: '配置中心-应用配置-mixAction',
                component: () => import('../pages/configcenter/fileManager/fileItem.vue'),
                children: []
            },
            {
                path: ':action(configGlobal)',
                name: '配置中心-应用配置-mixAction',
                component: () => import('../pages/configcenter/fileManager/globalConfig.vue'),
                children: []
            },
            {
                path: 'midfilemanage',
                realPath: '/configcenter/midfilemanage',
                name: '中间件配置',
                component: () => import('../pages/configcenter/midFileManager/midfileManage.vue'),
                children: []
            },
            {
                path: ':action(midedit)',
                name: '配置中心-中间件配置-mixAction',
                component: () => import('../pages/configcenter/midFileManager/midfileItem.vue'),
                children: []
            },
            {
                path: 'rizhi',
                realPath: '/configcenter/rizhi',
                name: '日志级别',
                component: () => import('../pages/configcenter/log/list'),
                children: []
            },
            {
                path: 'configlog',
                realPath: '/configcenter/configlog',
                name: '配置日志',
                component: () => import('../pages/configcenter/appConfigLog/list.vue'),
                children: []
            },
            {
                path: ':action(detaillog)',
                name: '配置中心-配置日志-mixAction',
                component: () => import('../pages/configcenter/appConfigLog/item.vue'),
                children: []
            },
            {
                path: 'midconfiglog',
                realPath: '/configcenter/midconfiglog',
                name: '配置中间件',
                component: () => import('../pages/configcenter/appConfigLog/midlist.vue'),
                children: []
            },
            {
                path: ':action(middetaillog)',
                name: '配置中心-配置中间件-mixAction',
                component: () => import('../pages/configcenter/appConfigLog/miditem.vue'),
                children: []
            },

            {
                path: 'cloudconfig',
                realPath: '/configcenter/cloudconfig',
                name: '云端配置',
                component: () => import('../pages/cloudconfig'),
                children: [

                    {
                        path: 'configmanager',
                        realPath: '/configcenter/cloudconfig/configmanager',
                        name: '配置元数据',
                        component: () => import('../pages/cloudconfig/configmanager/list'),
                        children: []
                    },
                    {
                        path: ':action(addconfig|editconfig|detailconfig)',
                        name: '云端配置-配置元数据-mixAction',
                        component: () => import('../pages/cloudconfig/configmanager/item'),
                        children: []
                    },
                    {
                        path: 'configdetail',
                        realPath: '/configcenter/cloudconfig/configdetail',
                        name: '配置明细',
                        component: () => import('../pages/cloudconfig/configdetail/list'),
                        children: []
                    },
                    {
                        path: ':action(addconfigdetail|editconfigdetail|detailconfigdetail|convertconfigdetail)',
                        name: '云端配置-配置明细-mixAction',
                        component: () => import('../pages/cloudconfig/configdetail/item'),
                        children: []
                    },
                    {
                        path: 'simpleconfig',
                        realPath: '/configcenter/cloudconfig/simpleconfig',
                        name: '简单配置',
                        component: () => import('../pages/cloudconfig/simpleconfig/list'),
                        children: []
                    },
                    {
                        path: ':action(addsimpconfig|editsimpconfig|detailsimpconfig)',
                        name: '云端配置-简单配置-mixAction',
                        component: () => import('../pages/cloudconfig/simpleconfig/item'),
                        children: []
                    },
                ]
            },
        ]
    },
    {
        path: '/rc',
        name: '风控管理',
        icon: 'cloud-server',
        component: () => import('../pages/rc'),
        children: [
            {
                path: 'rule',
                realPath: '/rc/rule',
                name: '风控规则',
                component: () => import('../pages/rc/rule'),
                children: [
                    {
                        path: 'list',
                        realPath: '/rc/rule/list',
                        name: '风控管理-风控规则-规则列表',
                        component: () => import('../pages/rc/rule/list'),
                        children: []
                    },
                    {
                        path: ':action(add|edit|detail)',
                        name: '风控管理-风控规则-规则列表-mixAction',
                        component: () => import('../pages/rc/rule/item'),
                        children: []
                    },
                ]
            },

            {
                path: 'io',
                realPath: '/rc/io',
                name: '流量控制',
                component: () => import('../pages/rc/io'),
                children: [
                    {
                        path: 'list',
                        realPath: '/rc/io/list',
                        name: '风控管理-流量控制-系统列表',
                        component: () => import('../pages/rc/io/list'),
                        children: []
                    },
                    {
                        path: 'config',
                        realPath: '/rc/io/config',
                        name: '风控管理-流量控制-配置列表',
                        component: () => import('../pages/rc/io/configlist'),
                        children: []
                    },
                    {
                        path: 'authservice',
                        realPath: '/rc/io/authservice',
                        name: '风控管理-流量控制-流控降级',
                        component: () => import('../pages/rc/io/authservice/applist'),
                        children: []
                    },
                    {
                        path: ':action(authappservice)',
                        name: '网关管理-流量控制-流控-mixAction',
                        component: () => import('../pages/rc/io/authservice/list'),
                        children: []
                    },
                    {
                        path: ':action(addriskconfig|editriskconfig|detailriskconfig|addappriskconfig|editappriskconfig)',
                        name: '网关管理-流量控制-流控降级-mixAction',
                        component: () => import('../pages/rc/io/authservice/configItem'),
                        children: []
                    },
                    {
                        path: 'serviceriskconfiglist',
                        realPath: '/rc/io/serviceriskconfiglist',
                        name: '风控管理-流量控制-服务流控降级',
                        component: () => import('../pages/rc/io/authservice/configlist'),
                        children: []
                    },
                ]
            },
            {
                path: 'namelist',
                realPath: '/rc/namelist',
                name: '名单管理',
                component: () => import('../pages/rc/namelist'),
                children: [
                    {
                        path: 'list',
                        realPath: '/rc/namelist/list',
                        name: '风控管理-名单管理-名单列表',
                        component: () => import('../pages/rc/namelist/list'),
                        children: []
                    },
                    {
                        path: ':action(add|edit|detail)',
                        name: '风控管理-名单管理-名单列表-mixAction',
                        component: () => import('../pages/rc/namelist/item'),
                        children: []
                    },
                    {
                        path: 'lishi',
                        realPath: '/rc/namelist/lishi',
                        name: '风控管理-名单管理-名单历史记录',
                        component: () => import('../pages/rc/namelist/list'),
                        children: []
                    },
                    {
                        path: 'zhixing',
                        realPath: '/rc/namelist/zhixing',
                        name: '风控管理-名单管理-防火墙执行记录',
                        component: () => import('../pages/rc/namelist/list'),
                        children: []
                    },
                ]
            },
        ]
    },

    {
        path: '/timetask',
        name: '定时任务',
        icon: 'bell',
        component: () => import('../pages/timetask'),
        children: [
            {
                path: 'tasklst',
                realPath: '/timetask/tasklst',
                name: '定时任务管理',
                component: () => import('../pages/timetask/tasklst.vue'),
                children: []
            },
            {
                path: ':action(add|edit)',
                name: '定时任务-定时任务管理-mixAction',
                component: () => import('../pages/timetask/taskitem.vue'),
                children: []
            },
            {
                path: ':action(detail)',
                name: '定时任务-定时任务管理详情-mixAction',
                component: () => import('../pages/timetask/taskhistory.vue'),
                children: []
            },
        ]
    },
    {
        path: '/servicekey',
        name: '网关管理',
        icon: 'fork',
        component: () => import('../pages/gateway/servicekey'),
        children: [
            {
                path: 'list',
                realPath: '/servicekey/list',
                name: '服务列表',
                component: () => import('../pages/gateway/servicekey/list'),
                children: []
            },
            {
                path: ':action(add|edit|detail|copy)',
                father: 'list',
                name: '网关管理-服务列表-mixAction',
                component: () => import('../pages/gateway/servicekey/item'),
                children: []
            },
            {
                path: ':action(compare)',
                name: '网关管理-测试环境同步-mixAction',
                component: () => import('../pages/gateway/servicekey/compare'),
                children: []
            },
            {
                path: 'jibie',
                realPath: '/servicekey/jibie',
                name: '服务级别',
                component: () => import('../pages/gateway/servicekey/list'),
                children: []
            },
            {
                path: 'authapp',
                realPath: '/servicekey/authapp',
                name: 'App授权',
                component: () => import('../pages/gateway/authapp/list'),
                children: []
            },
            {
                path: ':action(addapp|editapp|detailapp)',
                name: '网关管理-App授权-mixAction',
                component: () => import('../pages/gateway/authapp/appItem'),
                children: []
            },
            {
                path: 'processor',
                realPath: '/servicekey/processor',
                name: '网关管理-处理器映射',
                component: () => import('../pages/gateway/processor/list'),
                children: []
            },
            {
                path: ':action(add_processor|edit_processor|detail_processor)',
                name: '网关管理-处理器映射-mixAction',
                component: () => import('../pages/gateway/processor/item'),
                children: []
            },
            {
                path: 'processorClass',
                realPath: '/servicekey/processorClass',
                name: '网关管理-处理器配置',
                component: () => import('../pages/gateway/processorClass/list'),
                children: []
            },
            {
                path: ':action(add_processorClass|edit_processorClass|detail_processorClass)',
                name: '网关管理-处理器配置-mixAction',
                component: () => import('../pages/gateway/processorClass/item'),
                children: []
            },
        ]
    },
    {
        path: '/filemanager',
        name: '文件管理',
        icon: 'file',
        component: () => import('../pages/filemanager'),
        children: [
            {
                path: 'imexportmanager',
                realPath: '/filemanager/imexportmanager',
                name: '文件管理-导入导出管理',
                component: () => import('../pages/filemanager/imexportconfig/list'),
                children: []
            },
            {
                path: 'imexportrecord',
                realPath: '/filemanager/imexportrecord',
                name: '文件管理-导入导出记录',
                component: () => import('../pages/filemanager/imexportrecord/list'),
                children: []
            },
            {
                path: ':action(compare)',
                name: '文件管理-导入导出管理-mixAction',
                component: () => import('../pages/filemanager/compare/compare'),
                children: []
            },
            {
                path: ':action(add|edit|copy)',
                name: '文件管理-导入导出管理-mixAction',
                component: () => import('../pages/filemanager/imexportconfig/item'),
                children: []
            },
            {
                path: 'ossmanager',
                realPath: '/filemanager/ossmanager',
                name: '文件管理-OSS管理',
                component: () => import('../pages/filemanager/ossmanager/list'),
                children: []
            },
            {
                path: 'platform',
                realPath: '/filemanager/platform',
                name: '文件管理-平台管理',
                component: () => import('../pages/filemanager/platform/list'),
                children: []
            },


        ]
    },
    {
        path: '/jobcenter',
        name: '调度中心',
        icon: 'task',
        component: () => import('../pages/jobcenter'),
        children: [
            {
                path: 'jobstatus',
                realPath: '/jobcenter/jobstatus',
                name: '任务调度中心-运行报表',
                component: () => import('../pages/jobcenter/jobstatus/jobstatus'),
                children: []
            },
            {
                path: 'jobinfo',
                realPath: '/jobcenter/jobinfo',
                name: '任务调度中心-任务管理',
                component: () => import('../pages/jobcenter/jobinfo/list'),
                children: []
            },
            {
                path: 'joblog',
                realPath: '/jobcenter/joblog',
                name: '任务调度中心-调度日志',
                component: () => import('../pages/jobcenter/joblog/list'),
                children: []
            },
            {
                path: ':action(logdetail)',
                name: '任务调度中心-调度日志-mixAction',
                component: () => import('../pages/jobcenter/joblog/detail'),
                children: []
            },
            {
                path: 'jobgroup',
                realPath: '/jobcenter/jobgroup',
                name: '任务调度中心-执行器管理',
                component: () => import('../pages/jobcenter/jobgroup/list'),
                children: []
            },
        ]
    },
    {
        path: '/qualitymanager',
        name: '质量管理',
        icon: 'task',
        component: () => import('../pages/qualitymanager'),
        children: [
            {
                path: 'qualityreport',
                realPath: '/qualitymanager/qualityreport',
                name: '质量管理中心-质量报告',
                component: () => import('../pages/qualitymanager/qualityreport/framepage'),
                children: []
            }
        ]
    },
    {
        path: '/logservice',
        name: '日志管理',
        icon: 'form',
        component: () => import('../pages/logservice'),
        children: [
            {
                path: 'projectmanager',
                realPath: '/logservice/projectmanager',
                name: '日志管理-日志库',
                component: () => import('../pages/logservice/projectmanager/projectlist'),
                children: []
            },
            {
                path: ':action(projectadd)',
                name: '日志管理-项目管理-mixAction',
                component: () => import('../pages/logservice/projectmanager/projectitem.vue'),
                children: []
            },
            {
                path: 'logstoremanager',
                realPath: '/logservice/logstoremanager',
                name: '日志管理-日志库管理',
                component: () => import('../pages/logservice/logstoremanager/logstorelist'),
                children: []
            },
            {
                path: ':action(logstoreadd)',
                name: '日志管理-日志库管理-mixAction',
                component: () => import('../pages/logservice/logstoremanager/logstoreitem.vue'),
                children: []
            },


        ]
    },
    {
        path: '/setting',
        name: '系统设置',
        icon: 'setting',
        component: () => import('../pages/setting'),
        children: [
            {
                path: 'orglist',
                realPath: '/setting/orglist',
                name: '系统设置-组织管理',
                component: () => import('../pages/setting/orgmanage/orglist'),
                children: []

            },
            {
                path: ':action(orgadd|orgedit|orgdetail)',
                name: '系统设置-组织管理-mixAction',
                component: () => import('../pages/setting/orgmanage/orgitem.vue'),
                children: []
            },
            {
                path: 'userlist',
                realPath: '/setting/userlist',
                name: '系统设置-用户管理',
                component: () => import('../pages/setting/usermanage/userlist'),
                children: []

            },
            {
                path: ':action(adduser|edituser|detailuser)',
                name: '系统设置-用户管理-mixAction',
                component: () => import('../pages/setting/usermanage/useritem.vue'),
                children: []
            },
            {
                path: 'rolelist',
                realPath: '/setting/rolelist',
                name: '系统设置-角色权限管理',
                component: () => import('../pages/setting/rolemanage/rolelist'),
                children: []

            },
            {
                path: ':action(addrole|editrole|detailrole)',
                name: '系统设置-角色管理-mixAction',
                component: () => import('../pages/setting/rolemanage/roleitem.vue'),
                children: []
            },
            {
                path: ':action(roleauth)',
                name: '系统设置-角色管理-角色授权',
                component: () => import('../pages/setting/rolemanage/roleauth.vue'),
                children: []
            },
            {
                path: 'menulist',
                realPath: '/setting/menulist',
                name: '系统设置-菜单管理',
                component: () => import('../pages/setting/menumanage/menulist'),
                children: []

            },
            {
                path: 'noticelist',
                realPath: '/setting/noticelist',
                name: '系统设置-公告管理',
                component: () => import('../pages/setting/noticemanage/noticelist'),
                children: []

            },
            {
                path: ':action(noticeadd|noticeedit|noticedetail)',
                name: '系统设置-公告管理-mixAction',
                component: () => import('../pages/setting/noticemanage/noticeitem.vue'),
                children: []
            },
        ]
    },
    {
        path: '/ums',
        name: '账号中心',
        icon: 'setting',
        component: () => import('../pages/ums'),
        children: [
            {
                path: 'platfromlist',
                realPath: '/ums/platfromlist',
                name: '账号中心-平台管理',
                component: () => import('../pages/ums/platfrom/platfromlist'),
                children: []

            },
            {
                path: ':action(addPlatFrom|editPlatFrom|detailuser)',
                name: '账号中心-平台管理-mixAction',
                component: () => import('../pages/ums/platfrom/platfromitem.vue'),
                children: []
            },
            {
                path: ':action(platfromadduser|platfromedituser)',
                name: '账号中心-平台用户管理-mixAction',
                component: () => import('../pages/ums/platfrom/platfromadduser.vue'),
                children: []
            },
            {
                path: 'meunlist',
                realPath: '/ums/meunlist',
                name: '账号中心-菜单管理',
                component: () => import('../pages/ums/meun/list'),
                children: []

            },
            {
                path: 'yxl_meunlist',
                realPath: '/ums/yxl_meunlist',
                name: '账号中心-银响力菜单管理',
                component: () => import('../pages/ums/yxl_menu/list'),
                children: []

            },
            {
                path: 'role',
                realPath: '/ums/role',
                name: '账号中心-角色管理',
                component: () => import('../pages/ums/role/list'),
                children: []
            },
            {
                path: ':action(addrole|editrole|detailrole|authrole)',
                name: '账号中心-角色管理-mixAction',
                component: () => import('../pages/ums/role/item'),
                children: []
            },
            {
                path: 'userrole',
                realPath: '/ums/userrole',
                name: '账号中心-用户角色管理',
                component: () => import('../pages/ums/userrole/list'),
                children: []
            },
            // {
            //     path: 'fpuserrole',
            //     realPath: '/ums/fpuserrole',
            //     name: '账号中心-磐石用户管理',
            //     component: () => import('../pages/ums/userrole/fplist'),
            //     children: []
            // },
            // {
            //     path: ':action(editfpuseritem)',
            //     name: '账号中心-磐石用户管理-编辑-mixAction',
            //     component: () => import('../pages/ums/userrole/fpuseritem'),
            //     children: []
            // },
            {
                path: ':action(adduserrole|edituserrole|detailuserrole)',
                name: '账号中心-用户角色管理-详情-mixAction',
                component: () => import('../pages/ums/userrole/item'),
                children: []
            },
            {
                path: 'user',
                realPath: '/ums/user',
                name: '账号中心-用户管理',
                component: () => import('../pages/ums/user/list'),
                children: []
            },
            {
                path: ':action(edituser)',
                name: '账号中心-用户管理-编辑-mixAction',
                component: () => import('../pages/ums/user/item'),
                children: []
            },
            {
                path: ':action(edituserauth)',
                name: '账号中心-用户授权-mixAction',
                component: () => import('../pages/ums/user/userauthitem'),
                children: []
            },
        ]
    },

    {
        path: '/monitorerror',
        name: '异常分析',
        icon: 'bar-chart',
        component: () => import('../pages/monitorerror'),
        children: [
            {
                path: 'overview',
                realPath: '/monitorerror/overview',
                name: '异常分析-系统概览',
                component: () => import('../pages/monitorerror/overview/overview'),
                children: []
            },
            {
                path: 'trend',
                realPath: '/monitorerror/trend',
                name: '异常分析-趋势分析',
                component: () => import('../pages/monitorerror/trend/trend'),
                children: []
            },
            {
                path: 'history',
                realPath: '/monitorerror/history',
                name: '异常分析-历史数据',
                component: () => import('../pages/monitorerror/history/history'),
                children: []
            },
            {
                path: ':action(errordetail)',
                name: '异常分析-异常详情-mixAction',
                component: () => import('../pages/monitorerror/trend/item'),
                children: []
            },
        ]
    },

    {
        path: '/mqinfo',
        name: 'mq消息监控',
        icon: 'bar-chart',
        component: () => import('../pages/mqinfo'),
        children: [
            {
                path: 'resendlog',
                realPath: '/mqinfo/resendlog',
                name: 'MQ消息回放',
                component: () => import('../pages/mqinfo/resendlog'),
                children: []
            },
            {
                path: 'queuelist',
                realPath: '/mqinfo/queuelist',
                name: 'MQ队列监控',
                component: () => import('../pages/mqinfo/queuelist'),
                children: []
            },
            {
                path: 'list',
                realPath: '/mqinfo/list',
                name: 'MQ消息查询',
                component: () => import('../pages/mqinfo/list'),
                children: []
            },
            {
                path: 'mqsum',
                realPath: '/mqinfo/mqsum',
                name: 'MQ统计',
                component: () => import('../pages/monitorservice/appsum/appsum'),
                children: []
            }
        ]
    },
    {
        path: '/monitorservice',
        name: '服务监控',
        icon: 'bar-chart',
        component: () => import('../pages/monitorservice'),
        children: [
            {
                path: 'appsum',
                realPath: '/monitorservice/appsum',
                name: '服务监控-应用统计',
                component: () => import('../pages/monitorservice/appsum/appsum'),
                children: []
            },
            {
                path: 'myapp',
                realPath: '/monitorservice/myapp',
                name: '服务监控-我的关注',
                component: () => import('../pages/monitorservice/myapp/myapp'),
                children: []
            },
            {
                path: 'servicesum',
                realPath: '/monitorservice/servicesum',
                name: '服务监控-服务统计',
                component: () => import('../pages/monitorservice/servicesum/servicesum'),
                children: []
            },
            {
                path: 'log',
                realPath: '/monitorservice/log',
                name: '服务监控-调用日志',
                component: () => import('../pages/monitorservice/log/log'),
                children: []
            },
            {
                path: 'history',
                realPath: '/monitorservice/history',
                name: '服务监控-调用历史',
                component: () => import('../pages/monitorservice/history/history'),
                children: []
            },
            {
                path: 'relation',
                realPath: '/monitorservice/relation',
                name: '服务监控-调用链路',
                component: () => import('../pages/monitorservice/log/relation'),
                children: []
            },

        ]
    },
    {
        path: '/monitorweb',
        name: '前端监控',
        icon: 'bar-chart',
        component: () => import('../pages/monitorweb'),
        children: [
            {
                path: 'overview',
                realPath: '/monitorweb/overview',
                name: '前端监控-总览',
                component: () => import('../pages/monitorweb/overview/overview'),
                children: []
            },
            {
                path: 'monitor',
                realPath: '/monitorweb/monitor',
                name: '前端监控-JS错误',
                component: () => import('../pages/monitorweb/monitor/monitor'),
                children: []
            },
            {
                path: 'performance',
                realPath: '/monitorweb/performance',
                name: '前端监控-访问速度',
                component: () => import('../pages/monitorweb/performance/performance'),
                children: []
            }, {
                path: 'userbehavior',
                realPath: '/monitorweb/userbehavior',
                name: '前端监控-用户行为',
                component: () => import('../pages/monitorweb/userbehavior/userbehavior'),
                children: []
            },
            {
                path: 'logs',
                realPath: '/monitorweb/logs',
                name: '前端监控-日志分析',
                component: () => import('../pages/monitorweb/logs/logs'),
                children: []
            },
            {
                path: 'device',
                realPath: '/monitorweb/device',
                name: '前端监控-硬件分析',
                component: () => import('../pages/monitorweb/device/device'),
                children: []
            },
        ]
    },
    {
        path: '/open',
        name: '开放平台',
        icon: 'bar-chart',
        component: () => import('../pages/open'),
        children: [
            {
                path: 'demomanager',
                realPath: '/open/demomanager',
                name: '开放平台-模板管理',
                component: () => import('../pages/open/demomanager/demomanager'),
                children: []
            },
            {
                path: 'districtmanage',
                realPath: '/open/districtmanage',
                name: '开放平台-行政区域编码',
                component: () => import('../pages/open/districtManage/list'),
                children: []
            },
            {
                path: 'auth',
                realPath: '/open/auth',
                name: '开放平台-应用授权',
                component: () => import('../pages/open/auth/list'),
                children: []
            },
            {
                path: 'docmanager',
                realPath: '/open/docmanager',
                name: '开放平台-文档管理',
                component: () => import('../pages/open/docmanager/docmanager'),
                children: []
            },
            {
                path: ':action(adddoc|addapi|editdoc|editapi|addtemp|edittemp|addnotice|editnotice)',
                name: '开放平台-文档管理-mixAction',
                component: () => import('../pages/open/docmanager/doceditor'),
                children: []
            },
            {
                path: 'usermanager',
                realPath: '/open/usermanager',
                name: '开放平台-用户管理',
                component: () => import('../pages/open/usermanager/list'),
                children: []
            },
            {
                path: ':action(edituser)',
                name: '开放平台-用户管理-修改',
                component: () => import('../pages/open/usermanager/item'),
                children: []
            },
            // {
            //     path: ':action(resetpassword)',
            //     name: '开放平台-用户管理-修改',
            //     component: () => import('../pages/open/usermanager/resetpwd.vue'),
            //     children: []
            // },
            {
                path: 'httpdispatch',
                realPath: '/open/httpdispatch',
                name: '开放平台-业务回调配置',
                component: () => import('../pages/open/httpdispatch/list'),
                children: []
            },
            {
                path: 'callbackData',
                realPath: '/open/callbackData',
                name: '开放平台-回调数据',
                component: () => import('../pages/open/callbackData/list'),
                children: []
            },
            {
                path: ':action(adddispatch|editdispatch)',
                name: '开放平台-业务回调配置-mixAction',
                component: () => import('../pages/open/httpdispatch/item'),
                children: []
            },
            {
                path: 'callbackAppManage',
                realPath: '/open/callbackAppManage',
                name: '开放平台-回调应用管理',
                component: () => import('../pages/open/callbackAppManage/list'),
                children: []
            },
            {
                path: 'shortLinkManage',
                realPath: '/open/shortLinkManage',
                name: '开放平台-短链接管理',
                component: () => import('../pages/open/shortLinkManage/list'),
                children: []
            },
            {
                path: 'shortLinkType',
                realPath: '/open/shortLinkType',
                name: '开放平台-短链接业务类型管理',
                component: () => import('../pages/open/shotLinkType/list'),
                children: []
            },

        ]
    },
    {
        path: '/test',
        name: '磐石测试',
        icon: 'file-text',
        component: () => import('../pages/test'),
        children: [

            {
                path: 'test',
                realPath: '/test/test',
                name: '磐石测试-1',
                component: () => import('../pages/test/test'),
                children: []
            }
        ]
    },
    {
        path: '/wxmenus',
        name: '微信菜单',
        icon: 'file-text',
        component: () => import('../pages/wxmenus'),
        children: [

            {
                path: 'wxmenus',
                realPath: '/wxmenus/wxmenus',
                name: '微信菜单_',
                component: () => import('../pages/wxmenus/wxmenus'),
                children: []
            }
        ]
    },
    {
        path: '/processing',
        name: '报文处理v5',
        icon: 'file-text',
        component: () => import('../pages/processing'),
        children: [

            {
                path: 'manager',
                realPath: '/processing/manager',
                name: '报文处理',
                component: () => import('../pages/processing/manager/list'),
                children: []
            }
        ]
    },
    {
        path: '/project',
        name: '项目管理',
        icon: 'folder-outlined',
        component: () => import('../pages/project'),
        children: [

            {
                path: 'branchmanager',
                realPath: '/project/branchmanager',
                name: '分支管理',
                component: () => import('../pages/project/branchmanager/list'),
                children: []
            },
            {
                path: 'projectmanager',
                realPath: '/project/projectmanager',
                name: '项目管理',
                component: () => import('../pages/project/projectmanager/list'),
                children: []
            }
        ]
    },
    {
        path: '/redismanager',
        name: 'redis管理',
        icon: 'database',
        component: () => import('../pages/redismanager'),
        children: [
            {
                path: 'redislist',
                realPath: '/redismanager/redislist',
                name: 'redis列表',
                component: () => import('../pages/redismanager/redislist/list'),
                children: []
            },
            {
                path: 'nginxroute',
                realPath: '/redismanager/nginxroute/route',
                name: '主备切换',
                component: () => import('../pages/nginxroute/route/routesend/list'),
                children: []
            },
            {
                path: 'nginxroutedetail',
                realPath: '/redismanager/nginxroute/nginxroutedetail',
                name: '主备切换',
                component: () => import('../pages/nginxroute/route/route/list'),
                children: []
            }
        ]
    },
    {
        path: '/prod',
        name: '云监控',
        icon: 'thunderbolt',
        component: () => import('../pages/prod'),
        children: [
            {
                path: 'test',
                realPath: '/prod/test',
                name: '测试环境监控',
                component: () => import('../pages/prod/test/index'),
                children: []
            },
            {
                path: 'k8sv3',
                realPath: '/prod/k8sv3',
                name: 'K8S集群【V3】',
                component: () => import('../pages/prod/k8sv3/index'),
                children: []
            },
            {
                path: 'pospackage',
                realPath: '/prod/pospackage',
                name: '收银机打包工具',
                component: () => import('../pages/prod/pospackage/index'),
                children: []
            },
            {
                path: 'pospackageprod',
                realPath: '/prod/pospackageprod',
                name: '收银机打包工具',
                component: () => import('../pages/prod/pospackageprod/index'),
                children: []
            },
            {
                path: 'skywalking',
                realPath: '/prod/skywalking',
                name: 'skywalking',
                component: () => import('../pages/prod/skywalking/index'),
                children: []
            },
            {
                path: 'k8sv5',
                realPath: '/prod/k8sv5',
                name: 'K8S集群【V5】',
                component: () => import('../pages/prod/k8sv5/index'),
                children: []
            },
            {
                path: 'middlev3',
                realPath: '/prod/middlev3',
                name: '中间件【V3】',
                component: () => import('../pages/prod/middlev3/'),
                children: [
                    {
                        path: 'mq',
                        realPath: '/prod/middlev3/mq',
                        name: 'RocketMQ-v3',
                        component: () => import('../pages/prod/middlev3/mq/index.vue'),
                        children: []
                    },
                    {
                        path: 'redis',
                        realPath: '/prod/middlev3/redis',
                        name: 'redis',
                        component: () => import('../pages/prod/middlev3/redis'),
                        children: []
                    },
                ]
            },
            {
                path: 'middlev5',
                realPath: '/prod/middlev5',
                name: '中间件【V5】',
                component: () => import('../pages/prod/middlev5/index'),
                children: [
                    {
                        path: 'mq',
                        realPath: '/prod/middlev5/mq',
                        name: 'RocketMQ-v5',
                        component: () => import('../pages/prod/middlev5/mq'),
                        children: []
                    },
                    {
                        path: 'redisjt',
                        realPath: '/prod/middlev5/redisjt',
                        name: 'redis基础',
                        component: () => import('../pages/prod/middlev5/redisjt'),
                        children: []
                    },
                    {
                        path: 'rediszt',
                        realPath: '/prod/middlev5/rediszt',
                        name: 'redis中台',
                        component: () => import('../pages/prod/middlev5/rediszt'),
                        children: []
                    },
                    {
                        path: 'redisqt',
                        realPath: '/prod/middlev5/redisqt',
                        name: 'redis前台',
                        component: () => import('../pages/prod/middlev5/redisqt'),
                        children: []
                    },
                ]
            },
            {
                path: 'polardb',
                realPath: '/prod/polardb',
                name: 'PolarDB',
                component: () => import('../pages/prod/polardb/index'),
                children: []
            },
            {
                path: 'netaccess',
                realPath: '/prod/netaccess',
                name: '网络访问',
                component: () => import('../pages/prod/netaccess/index'),
                children: []
            }
        ]
    },
    {
        path: '/kamanager',
        name: 'KA环境管理',
        icon: 'usergroup-delete-outlined',
        component: () => import('../pages/kamanager'),
        children: [

            {
                path: 'kaenv',
                realPath: '/kamanager/kaenv',
                name: 'KA客户环境',
                component: () => import('../pages/kamanager/kaenv/list'),
                children: []
            },
            {
                path: 'bindsys',
                realPath: '/kamanager/bindsys',
                name: 'KA客户环境',
                component: () => import('../pages/kamanager/bindsys/list'),
                children: []
            },
            {
                path: ':action(newbindsys|detailbindsys|editbindsys)',
                name: 'KA私用环境管理-KA客户环境-mixAction',
                component: () => import('../pages/kamanager/bindsys/item'),
                children: []
            },
            {
                path: 'jenkins',
                realPath: '/kamanager/jenkins',
                name: 'KA私用环境管理-系统配置',
                component: () => import('../pages/kamanager/jenkins/list'),
                children: []
            },
            {
                path: ':action(add_jenkins|edit_jenkins|detail_jenkins)',
                name: 'KA私用环境管理-系统配置-mixAction',
                component: () => import('../pages/kamanager/jenkins/item'),
                children: []
            },
            {
                path: 'resource',
                realPath: '/kamanager/resource',
                name: 'KA私用环境管理-资源配置',
                component: () => import('../pages/kamanager/resource/item'),
                children: []
            },
            {
                path: 'domain',
                realPath: '/kamanager/domain',
                name: 'KA私用环境管理-域名管理',
                component: () => import('../pages/kamanager/domain/list'),
                children: []
            },
            {
                path: ':action(addDomain|editDomain|detailDomain)',
                name: 'KA私用环境管理-域名管理-mixAction',
                component: () => import('../pages/kamanager/domain/item'),
                children: []
            },
            {
                path: 'middleware',
                realPath: '/kamanager/middleware',
                name: 'KA私用环境管理-中间件',
                component: () => import('../pages/kamanager/middleware/list'),
                children: []
            },
            {
                path: ':action(addMiddleware|editMiddleware|detailMiddleware)',
                name: 'KA私用环境管理-中间件-mixAction',
                component: () => import('../pages/kamanager/middleware/item'),
                children: []
            },
        ]
    },

]

export default routesR
